import API from 'services/api';

interface IPayload {
  categoryId: number;
  subcategoryId: number | null;
  damageTypeId: number | null;
  damageCost: number | null;
  detailsText: string;
  escalateReport: number;
  rebookingAllowed: number;
}

interface IReportGuestMisconductResponse {
  success: boolean;
  message: string;
}

export const reportGuestMisconduct = ({
  calculationId,
  payload,
}: {
  calculationId: string;
  payload: IPayload;
}): Promise<IReportGuestMisconductResponse> =>
  API.post(
    `/api/accommodation/calculations/${calculationId}/booking/report-guest-misconduct`,
    payload,
  ).then(response => response?.data);
